import { DeepPartial, deepMerge } from '@websolutespa/bom-core';
import { LlmTheme } from '../types';
import theme from './theme.json';

export const DEFAULT_THEME: typeof theme & Record<string, any> = theme;

export function getThemes(overrides: (DeepPartial<LlmTheme> | undefined)[] = [], defaultTheme?: DeepPartial<LlmTheme> | undefined): LlmTheme {
  let theme = defaultTheme ? { ...defaultTheme } : { ...DEFAULT_THEME };
  overrides.forEach(override => {
    theme = deepMerge(theme, { ...override });
  });
  return theme;
}
